import {
  createBaseThemeOptions,
  createUnifiedTheme,
  palettes,
} from '@backstage/theme';

export const lightTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: palettes.light,
  }),
  defaultPageTheme: 'home',
  components: {
    BackstageContent: {
      styleOverrides: {
        root: ({ }) => ({
          paddingTop: '0.5%',
        }),
      },
    },
  },
});

export const darkTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: palettes.dark,
  }),
  defaultPageTheme: 'home',
  components: {
    BackstageContent: {
      styleOverrides: {
        root: ({ }) => ({
          paddingTop: '0.5%',
        }),
      },
    },
  },
});
